import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function Oralchirurgie() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-263">
      <Navigation data-id="element-264" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-265">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz" data-id="element-266">
          Oralchirurgie
        </h1>
      </main>
      <Footer data-id="element-267" />
    </div>;
}